import { useState } from "react";

import useIsomorphicLayoutEffect from "@brexhq/next/src/hooks/useIsomorphicLayoutEffect";
import { SanityTextRowProps } from "@brexhq/shared/types/modules/BlockRowsModule/BlockRowItems";

import { getInitialFontSize } from "../helpers";

const ARROW_SIZE_RATIO = 0.625;
const DEFAULT_ARROW_SIZE = 10;

export function useArrowSize(textStyle: SanityTextRowProps["textStyle"]) {
  const [arrowSize, setArrowSize] = useState(DEFAULT_ARROW_SIZE);

  useIsomorphicLayoutEffect(() => {
    const updateArrowSize = () => {
      if (typeof window !== "undefined" && window.innerWidth) {
        const fontSize = getInitialFontSize(textStyle, window.innerWidth);

        if (fontSize) {
          const calculatedSize = Number(fontSize) * ARROW_SIZE_RATIO;
          setArrowSize(calculatedSize);
        } else {
          setArrowSize(DEFAULT_ARROW_SIZE);
        }
      } else {
        setArrowSize(DEFAULT_ARROW_SIZE);
      }
    };

    updateArrowSize();

    const resizeObserver = new ResizeObserver(() => {
      updateArrowSize();
    });

    if (typeof document !== "undefined") {
      resizeObserver.observe(document.body);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [textStyle]);

  return arrowSize;
}
